<template>
  <PageTemplate>
    <h1>Pending Approval</h1>
    <div>
      <v-card :title="user.first_name + ' ' + user.last_name">
        <template>
          <v-data-list :data="roles" />
          <div>
            <v-label text="CHANGE REQUEST IN" />
            <div
              v-for="(change,index) in currentRequest"
              :key="index"
            >
              <v-checkbox
                :id="index"
                @check="checkIn(index)"
              >
                <strong>{{ index.toUpperCase() }}</strong>
              </v-checkbox>
              <div class="row">
                <v-fieldset
                  class="col-md-4"
                  type="display"
                  text="From"
                  :value="user[index]"
                />
                <v-fieldset
                  class="col-md-4"
                  type="display"
                  text="To"
                  :value="change"
                />
              </div>
            </div>
            <div
              v-if="isUserInfo_Competency_modified()"
              class="row"
            >
              <div
                class="col-md-12 d-flex"
                style="margin-bottom: 10px;"
              >
                <v-checkbox
                  id="competency"
                  @check="checkIn('competency')"
                >
                  <strong>COMPETENCY CHANGES SUGGESTED</strong>
                </v-checkbox>
              </div>
              <div class="col-md-6 d-flex">
                <v-card title="Competency Details">
                  <v-button
                    size="lg"
                    :disabled="isCOmpetencyPDFUploaded()"
                    has-min-width
                    @click="viewTACompetency"
                  >
                    View Competencies
                  </v-button>
                </v-card>
              </div>
              <div class="col-md-6 d-flex">
                <v-card title="Suggested Changes">
                  <div class="col-md-12">
                    <div
                      v-if="competencySuggested.suggestChanges"
                      class="col-md-12"
                    >
                      <strong>Suggested Changes:</strong>
                      <br>
                      {{ competencySuggested.suggestChanges }}
                    </div>
                    <v-button
                      v-if="competencySuggested.document"
                      size="lg"
                      has-min-width
                      @click="viewTACompetency_SuggestedDoc(competencySuggested.document)"
                    >
                      Suggested Changes
                    </v-button>
                  </div>
                </v-card>
              </div>
            </div>
            <div
              v-if="isUserInfo_Emails_modified()"
              class="row"
            >
              <div
                class="col-md-12 d-flex"
                style="margin-bottom: 10px;"
              >
                <v-checkbox
                  id="user_info.csv_info.emails"
                  @check="checkIn('user_info.csv_info.emails')"
                >
                  <strong>EMAIL DETAILS UPDATED</strong>
                </v-checkbox>
              </div>
              <div class="col-md-6 d-flex">
                <v-card title="From - Email Details">
                  <div class="col-md-12 d-flex gap-in-list">
                    <div class="col-md-2">
                      Type
                    </div>
                    <div class="col-md-8">
                      Email
                    </div>
                    <div class="col-md-2 primaryTitle">
                      Primary
                    </div>
                  </div>
                  <div
                    v-for="item in user.user_info.csv_info.emails"
                    :key="item.Type"
                    class="col-md-12 d-flex gap-in-list"
                  >
                    <div class="col-md-2">
                      <strong>{{ item.Type }}:</strong>
                    </div>
                    <div class="col-md-8">
                      <strong>{{ item.email }}</strong>
                    </div>
                    <div class="col-md-2 primaryTitle">
                      <v-icon
                        v-if="item.isPrimary"
                        type="check-circle"
                        class="selected-icon"
                      />
                    </div>
                  </div>
                </v-card>
              </div>
              <div class="col-md-6 d-flex">
                <v-card title="To - Email Details">
                  <div class="col-md-12 d-flex gap-in-list">
                    <div class="col-md-2">
                      Type
                    </div>
                    <div class="col-md-8">
                      Email
                    </div>
                    <div class="col-md-2 primaryTitle">
                      Primary
                    </div>
                  </div>
                  <div
                    v-for="item in userInfo_Updated.csv_info.emails"
                    :key="item.Type"
                    class="col-md-12 d-flex gap-in-list"
                  >
                    <div class="col-md-2">
                      <strong>{{ item.Type }}:</strong>
                    </div>
                    <div class="col-md-8">
                      <strong :style="getHighlightStyle(item, user.user_info.csv_info.emails, 'email')">{{ item.email }}</strong>
                    </div>
                    <div
                      class="col-md-2 primaryTitle"
                      :style="getHighlightStyle(item, user.user_info.csv_info.emails, 'isPrimary')"
                    >
                      <v-icon
                        v-if="item.isPrimary"
                        type="check-circle"
                        class="selected-icon"
                      />
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
            <div
              v-if="isUserInfo_Phones_modified()"
              class="row"
            >
              <div
                class="col-md-12 d-flex"
                style="margin-bottom: 10px;"
              >
                <v-checkbox
                  id="user_info.csv_info.phones"
                  @check="checkIn('user_info.csv_info.phones')"
                >
                  <strong>PHONE DETAILS UPDATED</strong>
                </v-checkbox>
              </div>
              <div class="col-md-6 d-flex">
                <v-card title="From - Phone Details">
                  <div class="col-md-12 d-flex gap-in-list">
                    <div class="col-md-2">
                      Type
                    </div>
                    <div class="col-md-8">
                      Phone
                    </div>
                    <div class="col-md-2 primaryTitle">
                      Primary
                    </div>
                  </div>
                  <div
                    v-for="item in user.user_info.csv_info.phones"
                    :key="item.phoneNumber"
                    class="col-md-12 d-flex gap-in-list"
                  >
                    <div class="col-md-2">
                      <strong>{{ item.Type }}:</strong>
                    </div>
                    <div class="col-md-8">
                      <strong>{{ `${item.countryCode?item.countryCode:''}${item.phoneNumber?item.phoneNumber:''}` }}</strong>
                    </div>
                    <div class="col-md-2 primaryTitle">
                      <v-icon
                        v-if="item.isPrimary"
                        type="check-circle"
                        class="selected-icon"
                      />
                    </div>
                  </div>
                </v-card>
              </div>
              <div class="col-md-6 d-flex">
                <v-card title="To - Phone Details">
                  <div class="col-md-12 d-flex gap-in-list">
                    <div class="col-md-2">
                      Type
                    </div>
                    <div class="col-md-8">
                      Phone
                    </div>
                    <div class="col-md-2 primaryTitle">
                      Primary
                    </div>
                  </div>
                  <div
                    v-for="item in userInfo_Updated.csv_info.phones"
                    :key="item.phoneNumber"
                    class="col-md-12 d-flex gap-in-list"
                  >
                    <div class="col-md-2">
                      <strong>{{ item.Type }}:</strong>
                    </div>
                    <div class="col-md-8">
                      <strong :style="getHighlightStyle(item, user.user_info.csv_info.phones, 'phoneNumber')">{{ `${item.countryCode?item.countryCode:''}${item.phoneNumber?item.phoneNumber:''}` }}</strong>
                    </div>
                    <div
                      class="col-md-2 primaryTitle"
                      :style="getHighlightStyle(item, user.user_info.csv_info.phones, 'isPrimary')"
                    >
                      <v-icon
                        v-if="item.isPrimary"
                        type="check-circle"
                        class="selected-icon"
                      />
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
            <div
              v-if="isUserInfo_Addresses_modified()"
            >
              <div
                class="col-md-12 d-flex"
                style="margin-bottom: 10px;"
              >
                <v-checkbox
                  :id="`user_info.csv_info.addresses`"
                  @check="checkIn(`user_info.csv_info.addresses`)"
                >
                  <strong>ADDRESS UPDATED</strong>
                </v-checkbox>
              </div>
              <div
                v-for="(item, index) in user.user_info.csv_info.addresses"
                :key="index"
                class="row"
              >
                <div
                  v-if="isAddressTypeUpdated(item)"
                  class="col-md-12 d-flex"
                >
                  <div class="col-md-6">
                    <v-card
                      :title="`From - ${getAddressTitle(item)}`"
                    >
                      <div class="row">
                        <div class="col-md-12">
                          <div
                            v-if="item.isPrimary"
                            class="address-primary"
                          >
                            Primary&nbsp;&nbsp;&nbsp;
                            <v-icon
                              type="check-circle"
                              class="selected-icon"
                            />
                          </div>
                        </div>
                        <div
                          class="col-md-12"
                          :style="`${item.isPrimary?'':'margin-top:25px;'}`"
                        >
                          <div class="col-md-12 d-flex">
                            <div class="col-md-3">
                              Address
                            </div>
                            <div class="col-md-9">
                              <strong>{{ item.AddressLine }}</strong>
                            </div>
                          </div>
                          <div class="col-md-12 d-flex">
                            <div class="col-md-3">
                              Suburb
                            </div>
                            <div class="col-md-9">
                              <strong>{{ item.Suburb }}</strong>
                            </div>
                          </div>
                          <div class="col-md-12 d-flex">
                            <div class="col-md-3">
                              Country
                            </div>
                            <div class="col-md-9">
                              <strong>{{ item.Country }}</strong>
                            </div>
                          </div>
                          <div class="col-md-12 d-flex">
                            <div class="col-md-3">
                              State
                            </div>
                            <div class="col-md-9">
                              <strong>{{ item.State }}</strong>
                            </div>
                          </div>
                          <div class="col-md-12 d-flex">
                            <div class="col-md-3">
                              Post Code
                            </div>
                            <div class="col-md-9">
                              <strong>{{ item.Postcode }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </div>
                  <div class="col-md-6">
                    <v-card
                      :title="`To - ${getAddressTitle(item)}`"
                    >
                      <div class="row">
                        <div class="col-md-12">
                          <div
                            v-if="getUpdatedAddressTypeObject(item.Type).isPrimary"
                            class="address-primary"
                            :style="getUpdatedAddressTypeObject(item.Type).isPrimary == item.isPrimary?'':getHighlightColor()"
                          >
                            Primary&nbsp;&nbsp;&nbsp;
                            <v-icon
                              type="check-circle"
                              class="selected-icon"
                            />
                          </div>
                        </div>
                        <div
                          class="col-md-12"
                          :style="`${getUpdatedAddressTypeObject(item.Type).isPrimary?'':'margin-top:25px;'} width:100%;`"
                        >
                          <div class="col-md-12 d-flex">
                            <div class="col-md-3">
                              Address
                            </div>
                            <div class="col-md-9">
                              <strong
                                :style="getUpdatedAddressTypeObject(item.Type).AddressLine == item.AddressLine?'':getHighlightColor()"
                              >{{ getUpdatedAddressTypeObject(item.Type).AddressLine }}</strong>
                            </div>
                          </div>
                          <div class="col-md-12 d-flex">
                            <div class="col-md-3">
                              Suburb
                            </div>
                            <div class="col-md-9">
                              <strong
                                :style="getUpdatedAddressTypeObject(item.Type).Suburb == item.Suburb?'':getHighlightColor()"
                              >{{ getUpdatedAddressTypeObject(item.Type).Suburb }}</strong>
                            </div>
                          </div>
                          <div class="col-md-12 d-flex">
                            <div class="col-md-3">
                              Country
                            </div>
                            <div class="col-md-9">
                              <strong
                                :style="getUpdatedAddressTypeObject(item.Type).Country == item.Country?'':getHighlightColor()"
                              >{{ getUpdatedAddressTypeObject(item.Type).Country }}</strong>
                            </div>
                          </div>
                          <div class="col-md-12 d-flex">
                            <div class="col-md-3">
                              State
                            </div>
                            <div class="col-md-9">
                              <strong
                                :style="getUpdatedAddressTypeObject(item.Type).State == item.State?'':getHighlightColor()"
                              >{{ getUpdatedAddressTypeObject(item.Type).State }}</strong>
                            </div>
                          </div>
                          <div class="col-md-12 d-flex">
                            <div class="col-md-3">
                              Post Code
                            </div>
                            <div class="col-md-9">
                              <strong
                                :style="getUpdatedAddressTypeObject(item.Type).Postcode == item.Postcode?'':getHighlightColor()"
                              >{{ getUpdatedAddressTypeObject(item.Type).Postcode }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <v-button-group>
          <v-button
            size="lg"
            has-min-width
            :is-disabled="selectedChange.length === 0"
            @click="confirmationModal = true"
          >
            Approve
          </v-button>
          <v-button
            size="lg"
            color="danger"
            has-min-width
            :is-disabled="selectedChange.length === 0"
            @click="rejectionModal = true"
          >
            Reject
          </v-button>
        </v-button-group>
      </v-card>
      <v-button
        color="transparent"
        @click="$router.push('/admin/outstanding-activities')"
      >
        Cancel
      </v-button>
    </div>
    <v-modal
      v-if="confirmationModal"
      @close="closeModal"
    >
      <template #header>
        {{ isConfirmed ? 'Successful' : 'Confirmation' }}
      </template>
      <template v-if="isConfirmed">
        You have successfully approved
        {{ user.first_name }} {{ user.last_name }}’s request of changing his info
      </template>
      <template v-else>
        Are you sure you want to approve {{ user.first_name }} {{ user.last_name }}’s profile change?
      </template>
      <template #footer>
        <v-button-group is-right>
          <v-button
            v-if="!isConfirmed"
            size="lg"
            has-min-width
            @click="approve"
          >
            Yes, Approve
          </v-button>
          <v-button
            :color="isConfirmed ? 'primary' : 'secondary'"
            size="lg"
            has-min-width
            @click="closeModal"
          >
            {{ isConfirmed ? 'Got it' : 'Cancel' }}
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
    <v-modal
      v-if="rejectionModal"
      @close="closeModal"
    >
      <template #header>
        Reject with a reason
        {{ isConfirmed ? 'Successful' : 'Confirmation' }}
      </template>
      <template v-if="rejectionReasonSubmitted && isConfirmed">
        You have successfully rejected
        {{ user.first_name }} {{ user.last_name }} 's profile changes request!
      </template>
      <template v-else-if="rejectionReasonSubmitted && !isConfirmed">
        You Rejected {{ user.first_name }} {{ user.last_name }}’s profile changes request with following reason: <br>
        {{ rejectionReason }}
        <br><br>
        Are you sure you want to continue?
      </template>
      <template v-else>
        <v-fieldset
          v-model="rejectionReason"
          type="textarea"
        />
      </template>
      <template #footer>
        <v-button-group is-right>
          <v-button
            v-if="rejectionReasonSubmitted && !isConfirmed"
            size="lg"
            has-min-width
            @click="reject"
          >
            Yes, continue
          </v-button>
          <v-button
            v-if="!rejectionReasonSubmitted"
            size="lg"
            color="danger"
            has-min-width
            :is-disabled="!rejectionReason"
            @click="rejectionReasonSubmitted = true"
          >
            Reject
          </v-button>
          <v-button
            :color="isConfirmed ? 'primary' : 'secondary'"
            size="lg"
            has-min-width
            @click="closeModal"
          >
            {{ isConfirmed ? 'Got it' : 'Cancel' }}
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page";
  import Card from "@/molecules/Card";
  import Icon from "@/atoms/Icon";
  import Label from "@/atoms/Label";
  import Modal from "@/atoms/Modal";
  import Checkbox from "@/atoms/Checkbox";
  import Button from "@/atoms/Button";
  import DataList from "@/atoms/DataList";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Fieldset from "@/molecules/Fieldset";
  import {buildBreadCrumb,buildDefinitionList} from "@/common/tableFunctions"
  import {
    APPROVE_USER_REQUEST,
    GET_USER_REQUEST
  } from "@/store/actions.type";
  import constants from "@/common/constants";
  import routes from "@/common/routes";
  import {mapState} from "vuex";
  import _ from 'lodash';
  import ApiService from "@/common/apiService";

  export default {
    name: "Users",
    components: {
      "v-card": Card,
      "v-label":Label,
      "v-checkbox": Checkbox,
      "v-button-group": ButtonGroup,
      "v-button": Button,
      "v-data-list": DataList,
      "v-modal": Modal,
      "v-fieldset": Fieldset,
      "v-icon": Icon,
      PageTemplate
    },
    data: () => ({
      confirmationModal: false,
      rejectionModal: false,
      rejectionReason: '',
      rejectionReasonSubmitted: false,
      isConfirmed: false,
      selectedChange:[],
      currentRequest: null,
      userInfo_Updated: null,
      competencySuggested: null
    }),
    computed: {
      ...mapState({
        users: state => state.userRequest.users,
        profileChanges: state => state.userRequest.profileChanges
      }),
      user: function(){
        let id = this.$route.params.id;
        return this.profileChanges.filter(el => el.id == id)[0].user;
      },
      roles: function(){
        let id = this.$route.params.id;
        let roles = [];
        roles['User Type'] = this.profileChanges.filter(el => el.id == id)[0].user.roles.map(function(val){
          return constants.USER_ROLES.find(f => f.name == val.name).fullName
        }).join(',');
        return buildDefinitionList(roles);
      }
    },
    mounted() {
      this.updateBreadCrumb();
      this.getUsersRequest();
      let id = this.$route.params.id;
      const tempObj = JSON.parse(this.profileChanges.filter(el => el.id == id)[0].value);
      this.userInfo_Updated = tempObj.user_info;
      delete tempObj.user_info;
      this.competencySuggested = tempObj.competency;
      delete tempObj.competency;
      this.currentRequest = tempObj;
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Outstanding Activities'] = routes.ADMIN.OUTSTANDING_ACTIVITIES;
        breadcrumbs['All Pending Profile Change'] = routes.ADMIN.PENDING_PROFILE_CHANGE_ALL;
        breadcrumbs['Pending Approval'] = '';
        this.breadcrumbs = buildBreadCrumb(breadcrumbs);
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      getUsersRequest(){
        this.$store.dispatch(GET_USER_REQUEST);
      },
      closeModal: function () {
        this.confirmationModal = false;
        this.rejectionModal = false;
        this.rejectionReason = '';
        this.isConfirmed = false;
        this.$router.push(routes.ADMIN.OUTSTANDING_ACTIVITIES);
      },
      checkIn(index)
      {
        if(!this.selectedChange.includes(index))
        {
          this.selectedChange.push(index)
        }else{
          this.selectedChange.splice(this.selectedChange.findIndex(o => o == index), 1)
        }
      },
      approve(){
        let params = {};
        params.status = 'approve';
        params.type = 'update';
        params.data =  this.selectedChange;
        this.$store.dispatch(APPROVE_USER_REQUEST,[this.$route.params.id,params])
          .then(response => {
            this.$notify({
              title: 'Success',
              text: response.message,
              type: 'success'
            });
            this.isConfirmed = true;
          })
          .catch(error => {
            this.$notify({
              title: 'Error',
              text: 'Something went wrong.',
              type: 'error'
            });
          })
      },
      reject(){
        let params = {};
        params.status = 'reject';
        params.type = 'update';
        params.data =  this.selectedChange;
        params.reject_reason = this.rejectionReason;
        this.$store.dispatch(APPROVE_USER_REQUEST,[this.$route.params.id,params])
          .then(response => {
            this.$notify({
              title: 'Success',
              text: response.message,
              type: 'success'
            });
            this.isConfirmed = true;
          })
          .catch(error => {
            this.$notify({
              title: 'Error',
              text: 'Something went wrong.',
              type: 'error'
            });
          })
      },
      isUserInfo_Emails_modified() {
        if(!this.userInfo_Updated || !this.userInfo_Updated.csv_info.emails) {
          return false;
        }
        const emails = this.userInfo_Updated.csv_info.emails;
        const emailsOrg = this.user.user_info.csv_info.emails;
        return !_.isEqual(emails, emailsOrg);
      },
      isUserInfo_Phones_modified() {
        if(!this.userInfo_Updated || !this.userInfo_Updated.csv_info.phones) {
          return false;
        }
        const phones = this.userInfo_Updated.csv_info.phones;
        phones.map(e => {
          if(e.phoneNumber == '0') {
            e.phoneNumber = null;
          }
        })
        const phonesOrg = this.user.user_info.csv_info.phones;
        return !_.isEqual(phones, phonesOrg);
      },
      isUserInfo_Addresses_modified() {
        if(!this.userInfo_Updated || !this.userInfo_Updated.csv_info.addresses) {
          return false;
        }
        const addresses = this.userInfo_Updated.csv_info.addresses;
        addresses.map(e => {
          if(!e.Country && e.State == 'Other') {
            e.State = null;
          }
        })
        const addressesOrg = this.user.user_info.csv_info.addresses;
        return !_.isEqual(addresses, addressesOrg);
      },
      isAddressTypeUpdated(item) {
        const orgObj = this.getUpdatedAddressTypeObject(item.Type);
        return !_.isEqual(item, orgObj);
      },
      isUserInfo_Competency_modified() {
        return this.competencySuggested? true : false;
      },
      getHighlightStyle(item, orgEmails, attr) {
        const orgEle = orgEmails.filter(ele => ele.Type == item.Type)[0];
        return (orgEle[attr] === item[attr]) ? '': this.getHighlightColor();
      },
      getHighlightColor() {
        return 'background-color: yellow;';
      },
      getAddressTitle(item) {
        return item.Type + ' Address';
      },

      getUpdatedAddressTypeObject(type) {
        return this.userInfo_Updated.csv_info.addresses.filter(ele => ele.Type == type)[0];
      },
      isCOmpetencyPDFUploaded() {
        return !(this.user.user_info && this.user.user_info.competency_pdf_uri && this.user.user_info.competency_pdf_uri.indexOf(this.user.resource_id) !== -1);
      },
      viewTACompetency() {
        let url = `/admin/ta/competencypdf/${this.user.id}`;
        this.perfromViewAction(url);
      },
      viewTACompetency_SuggestedDoc(doc) {
        let url = `/admin/ta/competencysuggested/${doc}`;
        this.perfromViewAction(url);
      },
      perfromViewAction(url) {
        ApiService.get(url)
                .then(response => {
                    if(response.data.data)
                      window.open(response.data.data, '_blank');
                    else
                      this.$notify({
                        title: 'Error',
                        text:'Competency PDF is not available yet. Please contact administrator.',
                        type: 'error'
                      });
                })
                .catch(error => {
                  this.$notify({
                      title: 'Error',
                      text:'Competency PDF is not available yet. Please contact administrator.',
                      type: 'error'
                    });
                });
      }
    },
  }
</script>

